import React from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import "../assets/style.scss"

const LandingHeader = () => {
  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Block className="landing-header-text-wrapper">
        <Block className="landing-header-text">
          <Element type="h1" className="header-text1">{"Akbank Aile Bankacılığı"}</Element>
        </Block>
      </Block>
      <Image path={"./img/hayatadevamlead/hayata-devam-sigorta.png"} className="landing-header-img" />
    </Block>
  )
}

export default LandingHeader
